import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { HcpUpdateStatus } from "@models/HcpUpdateStatus";
import { GlobalVarsModel, LicenseTypes } from "@models/index";
import { TranslateModule } from "@ngx-translate/core";
import { UpdatesService } from "@providers/UpdatesService";
import { NewBaseService } from "@providers/newBase.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "hcp-update-modal",
  templateUrl: "./hcp-update-modal.html",
  styleUrls: ["./hcp-update-modal.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule],
})
export class HcpUpdateModal implements OnInit, OnDestroy {
  private updatesService: UpdatesService = inject(UpdatesService);
  private newBaseService = inject(NewBaseService);

  updateStatus: HcpUpdateStatus;
  isSpain = false;

  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.updatesService.updateStatus.pipe(takeUntil(this.destroy$)).subscribe((status) => {
      this.updateStatus = status;
    });

    this.newBaseService.getVars.pipe(takeUntil(this.destroy$)).subscribe((data: GlobalVarsModel) => {
      this.isSpain =
        data.licenseType === LicenseTypes?.PaisVasco ||
        data.licenseType === LicenseTypes?.Nacional ||
        data.licenseType === LicenseTypes?.Madrid;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateLater() {
    this.updatesService.updateLater();
  }

  install() {
    this.updatesService.installUpdate();
  }

  download() {
    this.updatesService.startDownload();
  }

  get hcpUpdateStatus(): typeof HcpUpdateStatus {
    return HcpUpdateStatus;
  }
}
